<template>
  <div>
    <div class="map-container" id="mapid">
    </div>
  </div>
</template>

<script>
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

/* This code is needed to properly load the images in the Leaflet CSS */
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

let icon = L.icon({
  iconUrl: require('../../../assets/images/marker.png'),
  iconSize: [38, 51]
});


export default {
  name: "wLeafletMapChart",
  props: {
    silos: {
      required: true,
      type: Array
    }
  },
  data: function () {
    return {
      token: "pk.eyJ1IjoibWNvcmRhc2NvIiwiYSI6ImNqczRzNGNmNDA4Nnk0NHFwNnVwOXZyZ2cifQ.7aVtbF9aUUxWoRbsJE4oMw",
      leafletMarkers: [],
      layer: undefined,
      map: undefined,
      allData: [],
    }
  },
  mounted() {

    let map = L.map('mapid');
    this.map = map;
    this.layer = L.tileLayer('https://api.mapbox.com/styles/v1/mapbox/satellite-streets-v11/tiles/{z}/{x}/{y}?access_token=' + this.token, {
      maxZoom: 18,
      tileSize: 512,
      zoomOffset: -1,
    });
    this.layer.addTo(map);

    if (this.silos !== undefined && this.silos.length > 0) {
      this.setMarkers(map, this.silos);
    }

  },
  watch: {

    silos: function (newVal) {
      if (newVal !== undefined && newVal.length > 0) {
        this.setMarkers(this.map, newVal);
      }
    }
  },
  methods: {
    setMarkers: function (map, silos) {
      for (let i = 0; i < this.leafletMarkers.length; i++) {
        this.map.removeLayer(this.leafletMarkers[i]);
      }
      if (silos !== undefined && silos.length > 0) {
        silos.forEach(silo => {

          if (silo.position !== undefined
              && silo.position.lat !== undefined
              && silo.position.long !== undefined
              && silo.position.lat !== ""
              && silo.position.long !== "") {
            let leafletMarker = L.marker([silo.position.lat, silo.position.long], {
              icon: icon
            });
            leafletMarker.on('click', function (e) {
              map.setView(e.latlng, 18);
            });
            leafletMarker.addTo(map).bindPopup('<b style="font-weight: bold">' + silo.siteName + '</b><br>' + silo.nombre).openPopup();
            this.leafletMarkers.push(leafletMarker)
          }

        });

        let group = new L.featureGroup(this.leafletMarkers);
        map.fitBounds(group.getBounds(), {animate: true});
      } else {
        map.locate({setView: true, maxZoom: 16});
      }

    }
  }
}
</script>

<style lang="scss">
.map-container {
  width: 100%;
  height: 38em;
  border-radius: 10px;
}

</style>